import { useEffect, useLayoutEffect, useRef } from "react";

export const useAutoResizeTextarea = (message: string) => {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useLayoutEffect(() => {
    const element = textareaRef.current;
    if (!element) {
      return;
    }
    // Reset to auto first so scrollHeight reflects true content height, not the previous set value
    element.style.height = "auto";
    element.style.height = `${element.scrollHeight}px`;
  }, [message]);

  useEffect(() => {
    const element = textareaRef.current;
    if (!element) {
      return;
    }
    const resizeObserver = new ResizeObserver(() => {
      // Reset to auto first so scrollHeight reflects true content height, not the previous set value
      element.style.height = "auto";
      element.style.height = `${element.scrollHeight}px`;
    });
    resizeObserver.observe(element);

    return () => {
      return resizeObserver.disconnect();
    };
  }, []);

  return textareaRef;
};
